<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'
        width= '180'>
      </el-table-column>
      <el-table-column
        prop= 'deviceInstantiationGroup.name'
        label= '设备组'
        width= '260'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>
      <el-table-column
        prop= 'status'
        label= '状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.status===1">可用</el-button>
          <el-button type='danger' size='small' v-if="scope.row.status===0">禁用</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'optType'
        label= '规则类型'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.optType==='or'">或</el-button>
          <el-button type='danger' size='small' v-if="scope.row.optType==='and'">与</el-button>
          <el-button type='warning' size='small' v-if="scope.row.optType==='pid_temperature'">温度PID调节</el-button>
        </template>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '260'>
        <template slot-scope='scope'>
          <el-button @click='detailRule(scope.row)' type='text' size='small' style="color: #209323">详情</el-button>
          <el-button @click='manageDeviceControlRuleCondition(scope.row)' type='text' size='small' style="color: #209323">执行条件</el-button>
          <el-button @click='manageDeviceControlRuleAction(scope.row)' type='text' size='small' style="color: #209323">执行指令</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="设备组" :label-width="formLabelWidth" prop="name">
          <el-select v-model="form.deviceInstantiationGroupId" placeholder="请选择">
            <el-option v-for="item in deviceInstantiationGroups" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
          <el-radio v-model="form.status" :label=0>禁用</el-radio>
          <el-radio v-model="form.status" :label=1>激活</el-radio>
        </el-form-item>
        <el-form-item label="规则类型" :label-width="formLabelWidth" prop="optType">
          <el-radio v-model="form.optType" label='or'>或</el-radio>
          <el-radio v-model="form.optType" label='and'>与</el-radio>
          <el-radio v-model="form.optType" label='pid_temperature'>温度pid调节</el-radio>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off" type="textarea" :rows="12"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="curRow.name + '  执行条件'" :visible.sync="dialogDeviceControlRuleConditionVisible" width="98%" top="0" :fullscreen="true" :modal="false">
      <DeviceControlRuleCondition :deviceControlRuleId="curRow.id" :deviceInstantiationGroupId="curRow.deviceInstantiationGroupId"></DeviceControlRuleCondition>
    </el-dialog>

    <el-dialog :title="curRow.name + '  执行指令'" :visible.sync="dialogDeviceControlRuleActionVisible" width="98%" top="0" :fullscreen="true" :modal="false">
      <DeviceControlRuleAction :deviceControlRuleId="curRow.id" :deviceInstantiationGroupId="curRow.deviceInstantiationGroupId"></DeviceControlRuleAction>
    </el-dialog>

    <el-dialog :title="curRow.name + ' ---- 智能控制详情'" :visible.sync="dialogDetailVisible">
      <el-row>
        <el-row style="font-size: 20px;line-height: 40px;color: #f56c6c;" v-if="curRow.optType==='and'">全部同时满足时执行：</el-row>
        <el-row style="font-size: 20px;line-height: 40px;color: #f56c6c;" v-if="curRow.optType==='or'">满足任何一项时执行：</el-row>
        <el-col :span="24" v-for="deviceControlRuleCondition in deviceControlRuleConditions" :key="deviceControlRuleCondition.id" v-if="deviceControlRuleCondition.optTypeGroup==1">
          {{ deviceControlRuleCondition.deviceModelProperty?deviceControlRuleCondition.deviceModelProperty.name:'' }}{{ symbolFormat(deviceControlRuleCondition.symbol, deviceControlRuleCondition.val, deviceControlRuleCondition.timeQuantum) }}
        </el-col>
      </el-row>
      <el-row>
        <el-row style="font-size: 20px;line-height: 40px;color: #f56c6c;" v-if="curRow.optType2==='and'">且：全部同时满足时执行：</el-row>
        <el-row style="font-size: 20px;line-height: 40px;color: #f56c6c;" v-if="curRow.optType2==='or'">且：满足任何一项时执行：</el-row>
        <el-col :span="24" v-for="deviceControlRuleCondition in deviceControlRuleConditions" :key="deviceControlRuleCondition.id" v-if="deviceControlRuleCondition.optTypeGroup==2">
          {{ deviceControlRuleCondition.deviceModelProperty?deviceControlRuleCondition.deviceModelProperty.name:'' }}{{ symbolFormat(deviceControlRuleCondition.symbol, deviceControlRuleCondition.val, deviceControlRuleCondition.timeQuantum) }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="font-size: 16px;line-height: 50px;color: #B3B3B3;">执行：</el-col>
        <el-col :span="24" v-if="deviceControlRuleActions.length==0">&nbsp;&nbsp;&nbsp;&nbsp;无</el-col>
        <el-col :span="24" v-for="action in deviceControlRuleActions" :key="action.id">
          <el-row v-if="action.type==1">
            <el-col :span="8"  v-if="curRow.optType!='pid_temperature'&&action.doType==1" style="color:#64CA7E">· 满足执行:</el-col>
					  <el-col :span="8" t v-if="curRow.optType!='pid_temperature'&&action.doType==0" style="color:#EA0000">· 不满足执行:</el-col>
					  <el-col :span="8"  v-if="curRow.optType=='pid_temperature'&&action.doType==1" style="color:#64CA7E">· 增温执行:</el-col>
					  <el-col :span="8"  v-if="curRow.optType=='pid_temperature'&&action.doType==0" style="color:#EA0000">· 降温执行:</el-col>
					  <el-col :span="16"  style="padding-left: 10px;" v-if="action.deviceModelProperty.dataType=='boolean'">· {{deviceInstantiationsMapNames[action.deviceInstantiationSerialNo]?(deviceInstantiationsMapNames[action.deviceInstantiationSerialNo]+'/'):''}}{{action.deviceModelProperty.name}}&nbsp;{{action.val=='true'?'开启':'关闭'}}&nbsp;{{action.deviceModelProperty&&action.deviceModelProperty.unit?action.deviceModelProperty.unit:''}}</el-col>
					  <el-col :span="16"  style="padding-left: 10px;" v-if="action.deviceModelProperty.dataType!='boolean'">· {{deviceInstantiationsMapNames[action.deviceInstantiationSerialNo]?(deviceInstantiationsMapNames[action.deviceInstantiationSerialNo]+'/'):''}}{{action.deviceModelProperty.name}}&nbsp;{{action.val}}&nbsp;{{action.deviceModelProperty&&action.deviceModelProperty.unit?action.deviceModelProperty.unit:''}}</el-col>
          </el-row>
          <el-row v-if="action.type==9">
            <el-col :span="8"  v-if="action.doType==1" style="color:#64CA7E">· 满足发送:</el-col>
            <el-col :span="8"  v-if="action.doType==0" style="color:#EA0000">· 不满足发送:</el-col>
            <el-col :span="16"  v-if="action.val.indexOf('weixin')!=-1" style="padding-left: 10px;">· 微信【{{action.descr}}】</el-col>
            <el-col :span="16"  v-if="action.val.indexOf('sim')!=-1" style="padding-left: 10px;">· 手机【{{action.descr}}】</el-col>
            <el-col :span="16"  v-if="action.val.indexOf('devHint')!=-1" style="padding-left: 10px;">· 主控提醒【{{action.descr}}】</el-col>
            <el-col :span="16"  v-if="action.val.indexOf('cloudSpeaker')!=-1" style="padding-left: 10px;">· 云喇叭【{{action.descr}}】</el-col>
          </el-row>
          <el-row v-if="action.type==2">
            <el-col :span="8"  v-if="action.doType==1" style="color:#64CA7E">· 满足执行:</el-col>
            <el-col :span="8"  v-if="action.doType==0" style="color:#EA0000">· 不满足执行:</el-col>
            <el-col :span="16"  style="padding-left: 10px;">· 场景控制【{{action.descr}}】</el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import DeviceControlRuleAction from '../deviceControlRuleAction/Index.vue'
import DeviceControlRuleCondition from '../deviceControlRuleCondition/Index.vue'
export default {
  components: {
    DeviceControlRuleAction,
    DeviceControlRuleCondition
  },
  data () {
    return {
      dialogDetailVisible: false,
      dialogDeviceControlRuleActionVisible: false,
      dialogDeviceControlRuleConditionVisible: false,
      deviceInstantiationGroups: [],
      
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        descr: null,
        status: null,
        optType: null,
        deviceInstantiationGroupId: null
      },
      rules: {
        name: [{ required: true, message: '名称 不能为空', trigger: ['change', 'blur'] }, { message: '名称 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        status: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '状态 不能为空', trigger: ['change', 'blur'] }],
        optType: [{ required: true, message: '规则类型 不能为空', trigger: ['change', 'blur'] }, { message: '规则类型 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        deviceInstantiationGroupId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      curRow: {},
      deviceControlRuleActions: [],
      deviceControlRuleConditions: [],
      deviceInstantiationsMapNames: {}
    }
  },
  created () {
    this.query()
    this.loadDeviceInstantiationGroups()
    this.loadDeviceInstantiationsAll()
  },
  methods: {
			symbolFormat(symbol, value, timeQuantum) {
				if(symbol == 'timer'){
					return "单次定时:" + value
				}else if(symbol == 'cron'){
					let temp = value.split(' ');
					let index = temp.length;
					for(let i=temp.length-1; i>=0; i--){
						if(temp[i]!='*'&&temp[i]!='?'){
							index = i
							break;
						}
					}
					if(index==1){
						if((value+"").startsWith("*")){
							return "定时:每小时 " + temp[1] + "分"
						}else{
							return "定时:每小时 " + temp[1] + "分" + temp[0] + "秒"
						}
					}else if(index==2){
						return "定时:每天 " + temp[2] + "时" + temp[1] + "分"
					}else if(index==3){
						return "定时:每月 (" + temp[3] + ")日 " + temp[2] + "时" + temp[1] + "分"
					}else if(index==5){
						let weekCn = {'1':'一','2':'二','3':'三','4':'四','5':'五','6':'六','7':'日'}
						let weekStr = '';
						let weeks = temp[5].split(',');
						for(let w of weeks){
							weekStr = weekStr + weekCn[w] + ',';
						}
						weekStr = weekStr.substring(0, weekStr.length-1);
						return "定时:每周 (" + weekStr + ") " + temp[2] + "时" + temp[1] + "分"
					}
					return "循环定时:" + value
				}else if(symbol == '<(最近某时间段内极值)'){
					return symbol.replaceAll('某时间段', " ["+timeQuantum+"分钟] ") + " " + value;
				}else if(symbol == '>(最近某时间段内极值)'){
					return symbol.replaceAll('某时间段', " ["+timeQuantum+"分钟] ") + " " + value;
				}else if(symbol == '<(最近相邻数据差值)'){
					return symbol + " " + value;
				}else if(symbol == '>(最近相邻数据差值)'){
					return symbol + " " + value;
				}else if(symbol == 'dayTimeQuantum'){
					let strs = value.split("-")
					if(strs.length==1){
						return "执行时间段： " + strs[0] + "时"
					}else if(strs.length==2){
						if(!strs[1]||strs[1]==''){
							return "执行时间段： " + strs[0] + "时"
						}
						return "执行时间段： " + strs[0] + "-" + strs[1] + "时"
					}
				}else{
					return symbol + " " + value
				}
			},    
    loadDeviceInstantiationGroups () {
      let that = this
      requestService.get(`/deviceInstantiationGroup/listPage?current=1&pageSize=1024000`, {}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceInstantiationGroups = res.data.body.records
      })
    },
    detailRule (row) {
      let that = this
      that.curRow = {...row}
      that.dialogDetailVisible = true
      that.deviceControlRuleConditions = []
      that.deviceControlRuleActions = []
      requestService.get(`/deviceControlRuleAction/listPage?current=1&pageSize=1024000&deviceControlRuleId=${row.id}`, {}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceControlRuleActions = res.data.body.records
      })
      requestService.get(`/deviceControlRuleCondition/listPage?current=1&pageSize=1024000&deviceControlRuleId=${row.id}`, {}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceControlRuleConditions = res.data.body.records
      })
    },
    manageDeviceControlRuleCondition (row) {
      this.curRow = {...row}
      this.dialogDeviceControlRuleConditionVisible = true
    },
    manageDeviceControlRuleAction (row) {
      this.curRow = {...row}
      this.dialogDeviceControlRuleActionVisible = true
    },
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/deviceControlRule/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/deviceControlRule/listPage?current=${that.current}&pageSize=${that.pageSize}&injectDeviceInstantiationGroup=true`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    loadDeviceInstantiationsAll () {
      let that = this
      requestService.get(`/deviceInstantiation/listPage?current=1&pageSize=655350`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        for (let temp of res.data.body.records) {
	        that.deviceInstantiationsMapNames[temp.serialNo] = temp.name;
	      }
      })
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/deviceControlRule/add'
          if (that.form.id) {
            url = '/deviceControlRule/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/deviceControlRule/Index.vue